<template>
  <b-input-group :size="size">
    <template #prepend>
      <b-dropdown
          :size="size"
          :disabled="searching"
          :text="search_type_display"
          variant="secondary"
      >
        <b-dropdown-item
            :active="search_type === key"
            style="padding: 3px; font-size: 85%; margin: 0"
            v-for="(value, key) in search_type_choices"
            :key="key"
            @click.prevent="update_search_type(key)"
        >
          {{ value.verbose_name_plural }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <b-form-input
        aria-label="Input"
        v-on:keydown.enter.prevent
        @input="search_resource"
        :value="term"
        type="search"
        :placeholder="`Cerca nei ${search_type_display.toLowerCase()}`"
    ></b-form-input>
    <template v-if="searching" #append>
      <b-input-group-text>
        <b-icon icon="disc" animation="spin"></b-icon>
      </b-input-group-text>
    </template>
  </b-input-group>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";

const _ = require("lodash");
export default {
  props: {
    size: {
      default: "sm",
    },
  },
  methods: {
    ...mapActions("search", [
      "search",
      "update_term",
      "set_searching",
      "update_search_type",
    ]),
    search_resource: function (e) {
      if (e.trim().length < 3) return;
      this.set_searching(true);
      console.info("search_resource init", e, this.deb_promise);
      if (this.deb_promise) this.deb_promise.cancel();
      this.deb_promise = _.debounce(function (value) {
        console.info("search_resource", value);
        this.update_term(value);
        if (this.$router.currentRoute.name !== "search") {
          this.$router.push("/search");
        }
      }, 1200);
      this.deb_promise(e);
    },
  },
  computed: {
    ...mapState("search", ["term", "searching", "search_type"]),
    ...mapGetters("search", ["search_type_choices", "search_type_display"]),
    search_type_display: function () {
      const choices = this.search_type_choices;
      if (choices[this.search_type]) {
        return choices[this.search_type].verbose_name_plural;
      }
      // Se il tipo corrente non è tra quelli permessi, prendi il primo disponibile
      const firstKey = Object.keys(choices)[0];
      if (firstKey) {
        this.update_search_type(firstKey);
        return choices[firstKey].verbose_name_plural;
      }
      return "";
    },
  },
};
</script>
<style></style>
